import { myStyleDark, myStyleLight } from "../dist/helpers";
import codingCafe2 from "../images/coding-cafe2.jpg";

const items = [
  {
    head: "Built for Growth",
    body: "We partner with founders and engineering teams to design, build, and scale software that drives measurable outcomes. From first MVP to enterprise modernization, we ship reliable systems with clear roadmaps and transparent delivery — no surprises.",
  },
  {
    head: "Full-Stack Expertise",
    body: "Product strategy, UX, and engineering across modern web and cloud. React and TypeScript on the front end, reliable APIs and integrations on the back end, and scalable infrastructure on AWS and Azure — handled by one accountable team.",
  },
];

export default function About(props) {
  const { finalIsDarkMode } = props;
  const tc      = finalIsDarkMode ? "text-white" : "text-black";
  const mc      = finalIsDarkMode ? "text-white-50" : "text-muted";
  const surface = finalIsDarkMode ? myStyleDark : myStyleLight;

  return (
    <div className="py-4">

      {/* Full-bleed photo banner */}
      <div className="about-photo-card">
        <img src={codingCafe2} alt="Software development team working in a modern office" />
        <div className="about-photo-overlay" />
        <div
          style={{
            position: "absolute",
            bottom: 36,
            left: 48,
            zIndex: 2,
          }}
        >
          <span className="section-label" style={{ color: "#67e8f9" }}>
            About us
          </span>
          <h2 className="fw-bold text-white mb-0" style={{ fontSize: "2rem" }}>
            Who we are
          </h2>
        </div>
      </div>

      {/* Cards */}
      <div className="container">
        <div className="row g-4 mt-2">
          {items.map((item) => (
            <div className="col-md-6" key={item.head}>
              <div className="h-100 p-5 rounded-3 card-hover" style={surface}>
                <h3 className={`fw-bold mb-3 ${tc}`}>{item.head}</h3>
                <p
                  className={`mb-0 ${mc}`}
                  style={{ fontSize: "1.05rem", lineHeight: 1.75 }}
                >
                  {item.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
